import React, { useState } from "react";
import cx from "classnames";
import styles from "../../scss/AFDialog.module.scss";
import LModal from "../../../common/components/Modals/LModal/LModal";
import Button from "../../../common/components/Forms/Button/Button";

interface IAFImportantDialog {
    isOpen: boolean;
    onClose: (isContinue: boolean) => void;
    clientNumber: number;
}

const AFImportantDialog: React.FC<IAFImportantDialog> = (props) => {
    const { isOpen, onClose, clientNumber } = props;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="narrow"
            removePadding={true}
            isOpen={isOpen}
            onClose={() => onClose(false)}>
            {() => {
                return (
                    <div className={cx(styles["af-warning-dialog-modal"])}>
                        <div className={styles["af-warning__header"]}>
                            <h2>Important</h2>
                        </div>
                        <div className={styles["af-warning__content"]}>
                            <p className={styles["af-warning__desc"]}>
                                Changing applicant {clientNumber}'s details will likely alter the cost
                                of the selected cover from what was initially quoted.
                            </p>

                            <Button
                                className={styles["af-warning__continue"]}
                                width="fill"
                                component="button"
                                size="s"
                                onClick={() => {
                                    onClose(true);
                                }}
                                variant="calltoaction">
                                <span>Okay, Continue</span>
                            </Button>

                            <Button
                                className={styles["af-warning__cancel"]}
                                width="fill"
                                component="p"
                                size="s"
                                onClick={() => onClose(false)}
                                variant="default">
                                <span>Cancel</span>
                            </Button>
                        </div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default AFImportantDialog;
